import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes with tailwind-merge for deduplication
 * @param  {...any} inputs - Class names, arrays, or objects with conditional classes
 * @returns {string} - Merged and deduplicated class string
 */
// eslint-disable-next-line import/prefer-default-export
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
